export const SCREEN_TYPE = Object.freeze({
  home: 0,
  catalogue: 1,
  history: 2,
  expense_overview: 3,
});
